export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/forall/resources/mounted.js